/* jslint esversion: 6 */
/**
 * Header Menu
 *
 * @author Dylan James Wagner
 * @package Carbon
 * @subpackage Scripts
 * @since 3.0.0
 */
const $ = window.jQuery;
const s = {
	menuItems: $('.header-menu .menu__list > .menu-item-has-children'),
};

function init() {
	events();
}

function events() {

	s.menuItems.on('focusin focusout', function() {
		toggleARIAExpanded($(this));
	});
}

function toggleARIAExpanded($element) {

	if ($element.attr('aria-expanded') === 'true') {
		$element.attr('aria-expanded', 'false');
	}
	else {
		$element.attr('aria-expanded', 'true');
	}
}

export {init as default};



// WEBPACK FOOTER //
// /app/wp-content/themes/partnershipforthefuture/source/scripts/theme/header-menu.js